import {I18n} from 'react-redux-i18n';

export function getOrElse(firstKey, fallbackKey) {
  const rootKey = firstKey.substring(0, firstKey.lastIndexOf('.'));
  const searchedKey = firstKey.substring(firstKey.lastIndexOf('.') + 1, firstKey.length);
  return Object.keys(I18n.t(rootKey)).includes(searchedKey) ? I18n.t(firstKey) : I18n.t(fallbackKey);
}
